import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch";
import { AutogenLayoutMobileCommDriverError } from "./autogen/AutogenLayoutMobileCommDriverError";



const viewMCDriverErrorCodeURL = "lme/dispatch/mobilecomm/MobileCommDriverError?mode=update&key=";
const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "mc_error",
    screenName: "Mobile Comm Driver Error",
    navigateToUrl: viewMCDriverErrorCodeURL
};

export class MobileCommDriverError extends AutogenLayoutMobileCommDriverError {
    override onLoad(): void {
        DuplicateId.configureIdTextbox(this.textboxID, DUPLICATE_VALIDATION_PROPS);
    }
}

